import React, { useState, useEffect } from 'react';
import { OrderItem } from '../../../types/order';

interface OrderItemRowProps {
  item: OrderItem;
  recipes: { id: string; name: string }[];
  onChange: (item: OrderItem) => void;
  onRemove: () => void;
}

export const OrderItemRow: React.FC<OrderItemRowProps> = ({ item, recipes, onChange, onRemove }) => {
  const [localItem, setLocalItem] = useState(item);

  useEffect(() => {
    setLocalItem(item);
  }, [item]);

  const handleRecipeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedRecipe = recipes.find(r => r.id === e.target.value);
    if (selectedRecipe) {
      const updated = {
        ...localItem,
        recipeId: selectedRecipe.id,
        recipeName: selectedRecipe.name
      };
      setLocalItem(updated);
      onChange(updated);
    }
  };

  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const quantity = parseInt(e.target.value) || 1;
    const updated = { ...localItem, quantity };
    setLocalItem(updated);
    onChange(updated);
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '2fr 1fr auto',
        gap: '8px',
        marginBottom: '8px',
        alignItems: 'center'
      }}
    >
      <select
        value={localItem.recipeId}
        onChange={handleRecipeChange}
        style={{
          padding: '8px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '14px'
        }}
      >
        <option value="">Select recipe...</option>
        {recipes.map(recipe => (
          <option key={recipe.id} value={recipe.id}>
            {recipe.name}
          </option>
        ))}
      </select>

      <input
        type="number"
        value={localItem.quantity}
        onChange={handleQuantityChange}
        min="1"
        style={{
          padding: '8px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '14px'
        }}
      />

      <button
        type="button"
        onClick={onRemove}
        style={{
          padding: '8px 12px',
          backgroundColor: '#f44336',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        ×
      </button>
    </div>
  );
};
